
import api from "../lib/api";

export interface ContatoProjeto {
  id: number;
  nome: string;
  cargo?: string | null;
  empresa?: string | null;
  telefone?: string | null;
  email?: string | null;
}

export type ContatoInput = Omit<ContatoProjeto, "id">;

export async function listarContatos(projetoId: string): Promise<ContatoProjeto[]> {
  const response = await api.get(`/projetos/${projetoId}/contatos`);
  return response.data;
}

export async function criarContato(projetoId: string, data: ContatoInput): Promise<ContatoProjeto> {
  const response = await api.post(`/projetos/${projetoId}/contatos`, data);
  return response.data;
}

export async function atualizarContato(
  projetoId: string,
  contatoId: number,
  data: Partial<ContatoInput>
): Promise<ContatoProjeto> {
  const response = await api.put(`/projetos/${projetoId}/contatos/${contatoId}`, data);
  return response.data;
}

export async function excluirContato(projetoId: string, contatoId: number): Promise<void> {
  await api.delete(`/projetos/${projetoId}/contatos/${contatoId}`);
}
